import { Model } from '../base';

import { billingAPI } from '../../api';

export class BillingState {
  namespace = 'BillingState';

  // Initial values
  timelines: { userLicenseSet: { [key: string]: api.LicenseTimelineResponse } } = { userLicenseSet: {} };
  prices: { [key: string]: BillingAPI.Price } = {};
  customer: Customer = new Customer();
  credit: number = 0;
  currency: BillingAPI.Currency = 'USD';
  currentOrganizationProduct: BillingAPI.Product | null = null;
  allOrganizationsProducts: BillingAPI.Product[] | null = null;
  allOrganizationsTokens: BillingAPI.ProductToken[] | null = null;

  // Clear method for resetting values to initial state
  clear() {
    this.credit = 0;
    this.currency = 'USD';
    this.customer = new Customer();
    this.currentOrganizationProduct = null;
  }

  // Reserve token function
  reserveToken(
    orgID: string,
    productID: string,
    reservedUserId: string,
    reservedUserGroup: string,
    reservedUserEmail: string,
    amount: string,
    callback: () => void
  ) {
    const request: BillingAPI.ReserveTokenRequest = {
      orgID,
      productID,
      reservedUserId,
      reservedUserGroup,
      reservedUserEmail,
      amount,
    };

    billingAPI.reserveToken(request, callback);
  }

  // Load product details (version 2)
  loadProductDetailsV2(accessToken:string, orgID: string, sku: string, groupID: string, callback?: Function) {
    const request: BillingAPI.ProductRequestV2 = { accessToken, sku, orgID, groupID };
    billingAPI.getProduct(request, (error, response) => {
      if (error) return;
      const product: BillingAPI.Product = {
        id: response.body.id,
        sku: response.body.sku,
        name: response.body.name,
        description: response.body.description,
        price: response.body.price,
        currency: response.body.currency,
        duration: response.body.duration,
        freeTokens: '0',
      };
      this.currentOrganizationProduct = product;
      if (callback) callback(product);
    });
  }

  // Request a license
  requestLicense(accessToken:string, orgID: string, email: string, phone: string) {
    const request: BillingAPI.LicenseRequestRequest = {
      orgID,
      email,
      phone,
      accessToken
    };
    billingAPI.createLicenseRequest(request);
  }

  // Purchase a license
  purchaseLicense(accessToken:string, orgID: string, productID: string, productQuantity: string, name: string, callback: (error: any, action: any) => void) {
    const request: BillingAPI.UserInvoiceRequest = {
      productQuantity,
      orgID,
      productID,
      name,
      accessToken,
    };
    billingAPI.createUserInvoice(request, callback);
  }
}

// Customer class
class Customer extends Model<BillingAPI.CustomerResponse> implements BillingAPI.CustomerResponse {
  paymentMethod: string = '';
  last4Digits: string = '';

  // Load customer details
  load(accessToken: string,optionalCallback?: any) {
    billingAPI.getCustomer(accessToken,(error: any, response: any) => {
      if (!error) {
        this.responseHandler(error, response);
        this.paymentMethod = response.paymentMethod;
        this.last4Digits = response.last4Digits;
      }
      if (optionalCallback) optionalCallback(error, response);
    });
  }

  // Save customer details
  save(accessToken:string, creditCardToken: string, optionalCallback?: any) {
    const request = { creditCardToken,accessToken };
    const callback = (error: any, response: any) => {
      if (error) return;
      this.load(accessToken);
      if (optionalCallback) optionalCallback(response);
    };

    if (!this.isStored) {
      billingAPI.createCustomer(request, callback);
    } else {
      billingAPI.updateCustomer(request, callback);
    }
  }
}

let billingState = new BillingState();
// if (DEVELOPMENT) window['billingState'] = billingState;
export default billingState;
